export const tutorialTranslation = {
  en: {
    "S.No": "S.No",
    Title: "Title",
    Link: "Link",
    Status: "Status",
    "Created At": "Created At",
    Actions: "Actions",
    Home: "Home",
    Settings: "Settings",
    Landing: "Landing",
    Tutorials: "Tutorials",
    "+ Add Tutorial": "+ Add Tutorial",
    "Search by title...": "Search by title...",
    "Title (EN)": "Title (EN)",
    "Title (AR)": "Title (AR)",
    Active: "Active",
    Inactive: "Inactive",
    "Edit Tutorial": "Edit Tutorial",
    "Add New Tutorial": "Add New Tutorial",
    "Update Tutorial": "Update Tutorial",
    "Add Tutorial": "Add Tutorial",
    "Are you sure you want to delete tutorial '{{title}}'?":
      "Are you sure you want to delete tutorial '{{title}}'?",
    Cancel: "Cancel",
    Delete: "Delete",
    "This action cannot be undone.": "This action cannot be undone.",
    "Enter iframe tag": "Enter iframe tag",
    iframe: "iframe",
  },
  ar: {
    "S.No": "رقم",
    Title: "العنوان",
    Link: "الرابط",
    Status: "الحالة",
    "Created At": "تاريخ الإنشاء",
    Actions: "الإجراءات",
    Home: "الصفحة الرئيسية",
    Settings: "الإعدادات",
    Landing: "الموقع التعريفي",
    Tutorials: "الدروس",
    "+ Add Tutorial": "+ إضافة درس",
    "Search by title...": "البحث حسب العنوان...",
    "Title (EN)": "العنوان (EN)",
    "Title (AR)": "العنوان (AR)",
    Active: "نشط",
    Inactive: "غير نشط",
    "Edit Tutorial": "تعديل الدرس",
    "Add New Tutorial": "إضافة درس جديد",
    "Update Tutorial": "تحديث الدرس",
    "Add Tutorial": "إضافة درس",
    "Are you sure you want to delete tutorial '{{title}}'?":
      "هل أنت متأكد أنك تريد حذف الدليل '{{title}}'؟",
    Cancel: "إلغاء",
    Delete: "حذف",
    "This action cannot be undone.": "لا يمكن التراجع عن هذا الإجراء.",
    "Enter iframe tag": "أدخل علامة iframe",
    iframe: "إطار مضمّن ",
  },
};
